import ServiceAbstract from './ServiceAbstract'

export default class GoogleServiceAbstract extends ServiceAbstract {
  constructor(settings, CookieManager) {
    // Abstract constructor
    super(settings, CookieManager)

    if (this.constructor === GoogleServiceAbstract) {
      throw new TypeError('Abstract class "GoogleServiceAbstract" cannot be instantiated directly')
    }
  }

  getConsentModeStorages() {
    return []
  }

  buildConsentModeUpdate(status) {
    const update = {}
    this.getConsentModeStorages().forEach((storageType) => update[storageType] = status)

    return update
  }
}
